/** Original CevOp logomark: teal open C on black. Favicon / PWA / home-screen only — not beside the wordmark. */
export function CevopLogoMark({
  size = 32,
  className,
}: {
  size?: number;
  className?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 512 512"
      className={className}
      aria-hidden
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="512" height="512" fill="#000000" />
      <path
        d="M 372 118 A 158 158 0 1 0 372 394"
        fill="none"
        stroke="#00FFD5"
        strokeWidth={34}
        strokeLinecap="round"
      />
    </svg>
  );
}

/** Original CevOp wordmark: large thin C with “evop” inside. Masked from cevop-wordmark.png, tinted with brand teal. */
export function CevopWordmark({
  height = 18,
  className,
  decorative = false,
}: {
  height?: number;
  className?: string;
  decorative?: boolean;
}) {
  const size =
    height <= 16 ? 'cevop-wordmark-sm' : height >= 32 ? 'cevop-wordmark-lg' : 'cevop-wordmark-md';
  return (
    <span
      className={['cevop-wordmark', size, className].filter(Boolean).join(' ')}
      role={decorative ? undefined : 'img'}
      aria-label={decorative ? undefined : 'CevOp'}
      aria-hidden={decorative ? true : undefined}
      style={{ height, width: height * (2048 / 991) }}
    />
  );
}

/** Canonical in-app lockup: original wordmark only. Optional product label underneath. */
export function CevopBrand({
  wordmarkHeight = 18,
  product,
  className,
}: {
  wordmarkHeight?: number;
  product?: string;
  className?: string;
}) {
  return (
    <div className={['cevop-brand', className].filter(Boolean).join(' ')}>
      <CevopWordmark height={wordmarkHeight} />
      {product ? <div className="cevop-brand__product">{product}</div> : null}
    </div>
  );
}
